import Form from 'antd/lib/form'
import { EditableRow } from '../EditableRow/EditableRow'

export const EditableFormRow = Form.create()(EditableRow)
